import classnames from "classnames";
import React, { useCallback, useEffect, useRef } from "react";
import { needReload } from "src/components/Hyperlink/Hyperlink.component";

import { Slice } from "../components";
import { ISliceHtml } from "../types";
export const Html = ({
  slice_type,
  primary,
  items,
}: ISliceHtml): JSX.Element | null => {
  const {
    class_name: className,
    background_color: backgroundColor,
    html_custom: htmlCustom,
  } = primary;
  /**
   * Handle redirection with anchors <a>
   */
  const innerHtmlRef = useRef<HTMLDivElement>(null);

  const desktopRedirect = useCallback((e: MouseEvent, to): void => {
    if (needReload(to)) {
      e.preventDefault();

      window.location.assign(to);
    }
  }, []);

  useEffect(() => {
    if (innerHtmlRef.current) {
      const links = innerHtmlRef.current.querySelectorAll("a");

      const handleClick = (e: MouseEvent): void => {
        const target = e.currentTarget as HTMLAnchorElement;
        const to = target.href;

        desktopRedirect(e, to);
      };

      [...links].forEach((link) => {
        link.addEventListener("click", handleClick);

        return (): void => {
          link.removeEventListener("click", handleClick);
        };
      });

      // TODO: check onClick event
    }
  }, [desktopRedirect]);

  //
  const htmlText = htmlCustom[0].text;

  if (htmlText === undefined || htmlText === null) {
    return null;
  }

  const createMarkup = (): {
    __html: string;
  } => ({
    __html: htmlText,
  });

  return (
    <Slice
      className={classnames("slice-html", className)}
      backgroundColor={backgroundColor}
    >
      <div dangerouslySetInnerHTML={createMarkup()} ref={innerHtmlRef} />
    </Slice>
  );
};
